<template>
    <div>
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left"> External Fee Voucher Report </h1>
        </div>
        <div class="peopple-managment-main">
            <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="label block-label"> Challan No. </label>
                            <input type="text" v-model="challan_number" name="challan_number" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="label block-label"> Status </label>
                            <select v-model="status" name="status" class="form-control selectpicker custom-select2">
                                <option value="" selected>Select Option</option>
                                <option value="PAID">PAID</option>
                                <option value="PARTIALLY_PAID">PARTIALLY PAID</option>
                                <option value="UNPAID">UNPAID</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="label block-label"> From Date </label>
                            <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="label block-label"> To Date </label>
                            <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="label block-label"> Bifurcation </label>
                            <input type="text" v-model="bifurcation" name="bifurcation" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group align-right">
                            <br>
                            <button @click="getVoucherReport" v-if="!showBtn" class="btn btn-primary">Search</button>
                            <button @click="filterTable" v-if="showBtn" class="btn btn-primary">Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content" id="myTabContent">
        <div v-show="!hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
            <div class="empty-main pt-0" style="height: 100px">
                <div class="empty-inner">
                    <img src="/images/new_empty_payments.png" alt="" />
                    <h2> Hi, {{user}}! </h2>
                    <p> Select your requirements and export your desired report </p>
                </div>
            </div>
        </div>
        <div v-show="hasPer">
            <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs">
                <div class="field-box export-attendance">
                    <button class="btn btn-primary export" @click="exportReport">Export Report</button>
                </div>
            </div>


            <div class="tab-pane fade show active" id="" role="tabpanel" aria-labelledby="new-tab">
                <table id="vendorReportTable" class="table" style="width:100%">
                    <thead>
                        <tr>
                            <th style="display: none">ID</th>
                            <th>Branch Code</th>
                            <th>Student Name</th>
                            <th>Deposit Slip No.</th>
                            <th>Collection Date</th>
                            <th>Mode of Payment</th>
                            <th>Instrument No.</th>
                            <th>Amount</th>
                            <th>Credit Date</th>
                            <th>Roll No</th>
                            <th>Branch Name</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
    </div>
</template>


<script>
	var dtTable = null;
    export default {
        data() {
            return {
                // filter data
                from_date : '',
                to_date : '',
                challan_number : '',
                bifurcation : '',
                status : '',
				hasPer: false,
				user: '',
                showBtn: false,
                // permissions
				fee_voucher: null,
                fee_voucher_report: null
            };
        },
        mounted() {
            $('select.selectpicker').selectpicker();
            
			this.can('fee_voucher|fee_voucher_report').then(result => {
                this.fee_voucher = result.fee_voucher;
                this.fee_voucher_report = result.fee_voucher_report;
                this.user = result.user_name;
            });
        },
        methods: {
			filterTable(){
	            this.$Progress.start();
				dtTable.draw();
				this.$Progress.finish();
			},
			exportReport: function(){
				this.$Progress.start();
				var formData = {
					'to_date': moment(this.to_date).format('YYYY-MM-DD'),
					'from_date': moment(this.from_date).format('YYYY-MM-DD'),
					'status': this.status,
                    'challan_number': this.challan_number,
                    'bifurcation' : this.bifurcation,
                }
                axios.post('/api/externalFeeVouchersExport', formData,{
					responseType: 'blob'
				})
				.then(res => {
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'feeVoucherReport.xls')
					document.body.appendChild(link)
					link.click()
					this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load data');
				});
			},
            getVoucherReport: function(){
	            this.$Progress.start();
				var that = this;
				dtTable = $('#vendorReportTable').DataTable({
					sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
					processing: true,
					serverSide: true,
					ajax: {
						"url": "api/externalFeeVouchers",
						"data": function (d) {
							d.from_date = moment(that.from_date).format('YYYY-MM-DD');
							d.to_date = moment(that.to_date).format('YYYY-MM-DD');
							d.status = that.status;
                            d.challan_number = that.challan_number;
                            d.bifurcation = that.bifurcation;
						},
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
					deferRender: true,
					columns: [
						{data: 'id', visible: false},
						{render: function(data,type,full){
							return '0001';
						}},
                        {render: function(data,type,full){
                                if(full.reference_name != null){
                                    return full.reference_name;
                                }else{
                                    return "---";
                                }
                         }},
                        {render: function(data,type,full){
							if(full.challan_number != null){
								return full.challan_number;
							}else{
								return "---";
							}
						}},
                        {render: function(data,type,full){
                                if(full.transaction_date != null){
                                    return moment(full.transaction_date).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                        }},
                        {render: function(data,type,full){
                                return 'IBFT';
                        }},
                        {render: function(data,type,full){
                                if(full.transaction_number != null){
                                    return full.transaction_number;
                                }else{
                                    return "---";
                                }
                        }},
                        {render: function(data,type,full){
                                if(full.amount != null){
                                    return full.amount;
                                }else{
                                    return "---";
                                }
                        }},
                        {render: function(data,type,full){
                                if(full.transaction_date != null){
                                    return moment(full.transaction_date).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                         }},
                        {render: function(data,type,full){
                                if(full.reference_number != null){
                                    return full.reference_number;
                                }else{
                                    return "---";
                                }
                        }},
						{render: function(data,type,full){
                                return 'FINJA';
						}},
                        {render: function(data,type,full){
                            if(full.status != null){
                               if(full.status == 'PARTIALLY_PAID'){
                                return 'PARTIALLY PAID';
                            }else{
                                return full.status;

                            }
                        }else{
                            return "---";
                        }
                    }},
					],
					"order": [[ 0, "desc" ]],
					"initComplete": (res) => {
						that.hasPer = true;
						that.showBtn = true;
						setTimeout(function(){
							$('select.selectpicker').selectpicker();
						},300);
						that.$Progress.finish();
					}
				});
            }
        },
        created() {
			//
        }
    }
</script>
